import { useAuth } from "../auth/AuthContext";

export default function Settings() {
  const { user } = useAuth();
  return (
    <div className="page">
      <div className="page-head">
        <h1>Ayarlar</h1>
        <p className="page-sub">Hesap bilgileri ve uygulama tercihleri.</p>
      </div>

      <h2 className="section-title">Hesap</h2>
      <div className="card">
        <div className="detail-grid">
          <div><span className="dt">E-posta</span><span className="dd">{user?.email || "—"}</span></div>
          <div><span className="dt">Ad</span><span className="dd">{user?.full_name || "—"}</span></div>
          <div><span className="dt">Rol</span><span className="dd"><span className="badge ok">{user?.role || "—"}</span></span></div>
        </div>
      </div>

      <h2 className="section-title">Uygulama</h2>
      <div className="card">
        <div className="detail-grid">
          <div><span className="dt">Panel</span><span className="dd">MedReg AI — Admin</span></div>
          <div><span className="dt">Ortam</span><span className="dd">admin.medregai.com</span></div>
        </div>
      </div>

      <div className="card hint-card">
        <strong>Sıradaki adım:</strong> Genel uygulama ayarları (parola değiştirme, bildirim
        tercihleri vb.) bu sayfaya eklenecek.
      </div>
    </div>
  );
}
